(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb068"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb068"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $gPzri = parcelRequire("gPzri");

var $lkFGL = parcelRequire("lkFGL");

var $kqmYL = parcelRequire("kqmYL");
var $ba414ee46e403724$var$loginInfo = document.querySelector("#login-info");
var $ba414ee46e403724$var$logoutButton = document.querySelector("#logout-button");
document.addEventListener("DOMContentLoaded", function() {
    var accessToken = (0, $lkFGL.getAccessToken)();
    var refreshToken = (0, $gPzri.storage).getSessionData("refreshToken");
    if (accessToken && refreshToken && (0, $lkFGL.getLoggedInUserId)()) (0, $kqmYL.updateLoginState)();
    $ba414ee46e403724$var$authIframe.src = (0, $kqmYL.getLoginIframeSource)();
    (0, $kqmYL.setupEventListenersForIframe)($ba414ee46e403724$var$authIframe);
});
var $ba414ee46e403724$var$toggleLoginModalButton = document.querySelector("#toggle-login-modal-button");
var $ba414ee46e403724$var$authIframe = document.querySelector("#auth-iframe");
$ba414ee46e403724$var$toggleLoginModalButton.addEventListener("click", function() {
    var isHidden = window.getComputedStyle($ba414ee46e403724$var$authIframe).getPropertyValue("display") === "none";
    $ba414ee46e403724$var$authIframe.style.display = isHidden ? "block" : "none";
});
$ba414ee46e403724$var$logoutButton.addEventListener("click", function() {
    (0, $lkFGL.clearLogin)();
    $ba414ee46e403724$var$logoutButton.style.display = "none";
    $ba414ee46e403724$var$loginInfo.innerHTML = "Not logged in";
});

})();
//# sourceMappingURL=demo.897f7bbf.js.map
